














































import {
  mdiFullscreen,
  mdiFullscreenExit,
  mdiClose,
  mdiDelete,
  mdiPlus,
  mdiChevronRight,
  mdiChevronLeft,
  mdiPageFirst,
  mdiPageLast,
  mdiPlay,
  mdiPause
} from "@mdi/js";

import { Vue, Component, Prop, Provide } from "vue-property-decorator";
import { vxm } from "@/store";

@Component({
  components: {
    "key-press": () => import("vue-keypress")
  }
})
export default class SlideshowControls extends Vue {
  @Prop({ default: true }) readonly keyboard!: boolean;

  fullscreenIcon = mdiFullscreen;
  fullscreenExitIcon = mdiFullscreenExit;
  closeIcon = mdiClose;
  addBonusIcon = mdiPlus;
  deleteIcon = mdiDelete;
  nextIcon = mdiChevronRight;
  prevIcon = mdiChevronLeft;
  playIcon = mdiPlay;
  pauseIcon = mdiPause;
  firstIcon = mdiPageFirst;
  lastIcon = mdiPageLast;
  iconColor = "white";

  get mediumIndex() {
    return vxm.results.media.findIndex(medium => medium.id === this.$route.params.medium);
  }

  get nextMedium() {
    return vxm.results.media[this.mediumIndex + 1];
  }

  get prevMedium() {
    return vxm.results.media[this.mediumIndex - 1];
  }

  get lastMedium() {
    return vxm.results.media[vxm.results.media.length - 1];
  }

  get slideshow() {
    return vxm.results.slideshow;
  }

  toggleSlideshow() {
    if (this.slideshow) {
      vxm.results.setSlideshow(false);
    } else {
      vxm.results.setSlideshow(true);

      if (this.mediumIndex === -1) {
        this.$router.push(`/${vxm.results.eventId}/slideshow/${this.nextMedium.id}`);
      }
    }
  }

  toggleFullscreen() {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      document.documentElement.requestFullscreen();
    }
  }

  close() {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }

    this.$router.push(`/${vxm.results.eventId}/media`);
  }

  keyPress({ event }: { event: KeyboardEvent }) {
    if (!this.keyboard) {
      return;
    }

    if (event.keyCode === 39) {
      if (this.nextMedium) {
        this.$router.push(`/${vxm.results.eventId}/slideshow/${this.nextMedium.id}`);
      } else {
        this.$router.push(`/${vxm.results.eventId}/slideshow`);
      }
    } else if (event.keyCode === 37) {
      if (this.prevMedium) {
        this.$router.push(`/${vxm.results.eventId}/slideshow/${this.prevMedium.id}`);
      } else {
        this.$router.push(`/${vxm.results.eventId}/slideshow`);
      }
    }
  }
}
